<ng-container *ngIf="status">
  <ng-container *ngIf="status === 'queued'">
    <div class="status queued" [pTooltip]="'ui.message_status.queued' | translate">
      <img src="/assets/images/icons/clock.svg" alt="">
    </div>
  </ng-container>
  <ng-container *ngIf="status === 'sending' || status === 'accepted'">
    <div class="status sending" [pTooltip]="'ui.message_status.sending' | translate">
      <img src="/assets/images/icons/clock.svg" alt="">
    </div>
  </ng-container>
  <ng-container *ngIf="status === 'sent'">
    <div class="status sent" [pTooltip]="'ui.message_status.sent' | translate">
      <img src="/assets/images/icons/check.svg" alt="">
    </div>
  </ng-container>
  <ng-container *ngIf="status === 'delivered'">
    <div class="status delivered" [pTooltip]="'ui.message_status.delivered' | translate">
      <img src="/assets/images/icons/check.svg" alt="">
      <img src="/assets/images/icons/check.svg" alt="">
    </div>
  </ng-container>
  <ng-container *ngIf="status === 'read'">
    <div class="status read" [pTooltip]="'ui.message_status.read' | translate">
      <img [src]="'checkMessageIcon' | themeIconUrl: theme" alt="" >
      <img [src]="'checkMessageIcon' | themeIconUrl: theme" alt="" >
    </div>
  </ng-container>
  <ng-container *ngIf="status === 'failed' || status == 'undelivered'">
    <div class="status failed" [pTooltip]="'ui.message_status.undelivered' | translate"><img src="/assets/images/icons/alert.svg" alt=""></div>
  </ng-container>
  <ng-container *ngIf="status == 'unsubscribed'">
    <div class="status failed" pTooltip="Recipient has opted-out"><img src="/assets/images/icons/alert-alt.svg" alt=""></div>
  </ng-container>
</ng-container>
